/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Stack,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import {
  StyledTopicsHeader,
  StyledTopicSideBarInfoBox,
  StyledSidebarTopicButton,
} from "../../../common/StyledComponents/SideBarComponents";
import {
  CustomInput,
  SearchBox,
  ChatSearchButton,
  SmallIcon,
} from "../../../common/chatComponents/ScreenSearchSection";
import dragIcon from "../../../assets/images/task/dragicon.svg";
import addBlackIcom from "../../../assets/images/chats/AddBlack.svg";
import addIcom from "../../../assets/images/chats/Add.svg";
import searchIcon from "../../../assets/images/chats/gallery_active.svg";
import editTopics from "../../../assets/images/editTopic.svg";
import InputDialogComponent from "../../../components/InputDialog";
import SelectCheckBox from "../../../assets/images/chats/selectcheckbox.svg";
import UnSelectCheckBox from "../../../assets/images/chats/blankcheckbox.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  createTopic,
  getAlltopic,
  updateTopic,
} from "../../../appStore/actions/topics/action";
import {
  handleDeleteGroupTopic,
  handleFetchMessages,
  handleMoveChatToAnotherTopic,
  handleReOrderToipc,
} from "../../../appStore/actions/ArkchatGroup/action";
import {
  handleAppSelectedTopic,
  handleAppSelectedTopicToSaveMsg,
  handleChangeTopicOpen,
} from "../../../appStore/actions/AppState/action";
import { showToastMsg } from "../../../appStore/actions/global/action";

import {
  colorSchemes,
  crossIcon,
  crossIconDiv,
  fontSizeSchemes,
} from "../../../assets/commonFunction";
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
  DragOverlay,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import EditPencil from "../../../common/SvgImageView/EditPencil";
import { deleteTopicData } from "../../../config/db";
import { GET_TOPIC_DONE } from "../../../appStore/actions/topics";

const classes = {
  checkBoxStyle: {
    width: 25,
    height: 25,
    cursor: "pointer",
  },
  headingText: {
    color: "black",
    fontSize: "1rem",
    fontWeight: "400",
    "@media (max-width: 63rem)": {
      fontSize: "0.8rem",
    },
  },
  drawerBody: {
    minWidth: "393px",
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    height: "100%",
  },
  header: {
    backgroundColor: "#183243",
    color: "#fff",
    padding: "7px 8px",
  },
  iconDiv: crossIconDiv,
  iconDivRed: {
    backgroundColor: "#DB0011",
    position: "relative",
    height: "30px",
    width: "30px",
    padding: "4px",
    borderRadius: "2px",
    cursor: "pointer",
  },
  iconn: crossIcon,
  iconnWhite: {
    color: "white",
    height: "100%",
    width: "100%",
  },
  radiogp: {
    display: "block",
  },

  selectedItem: {
    // backgroundColor: "#183243",
    // color: "white",
    backgroundColor: "#E1E1E1",
    color: "#000",
    cursor: "pointer",
  },
  nonselectedItem: {
    color: "#000",
    cursor: "pointer",
  },
};

const SortableItem = ({
  ele,
  i,
  isMoveTopicTriggered,
  selectedTopic,
  isChangeTopicOpen,
  isTopicEditActive,
  selectedChangeTopic,
  selectedTopicToSaveMsg,
  handleChangeMoveTopic,
  handleSave,
  handleSelectedTopic,
  handleEditTopicOpen,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: ele?.id });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    width: "100%",
  };
  return (
    <Box
      {...(i !== 0 ? { ref: setNodeRef, style } : {})}
      display="flex"
      alignItems="center"
      width={"95%"}
      mt={"0.5rem"}
      marginLeft="auto"
      key={ele?.id + "topicdata" + i}
    >
      {i !== 0 && (
        <Box
          display={"flex"}
          alignItems={"center"}
          justifyContent={"center"}
          marginRight={"0.3rem"}
          sx={{
            cursor: "grab",
            borderRadius: "0.1rem",
            userSelect: "none",
            touchAction: "none",
            "&:hover": {
              backgroundColor: "#f0f0f0",
            },
            "&:active": {
              cursor: "grabbing",
            },
          }}
          {...attributes}
          {...listeners}
        >
          <img
            src={dragIcon}
            alt="dragIcon"
            style={{
              width: "14px",
              height: "14px",
              opacity: 0.6,
            }}
          />
        </Box>
      )}

      <Box
        position={"relative"}
        width={"100%"}
        padding={"0.2rem 0.5rem"}
        backgroundColor={colorSchemes.transparent}
        alignItems={"center"}
        borderRadius="0.1rem"
        marginRight={"0.3rem"}
        onClick={() => !isMoveTopicTriggered && handleSelectedTopic(ele)}
        sx={
          // eslint-disable-next-line eqeqeq
          selectedTopic?.id == ele?.id &&
          !isMoveTopicTriggered &&
          !isChangeTopicOpen
            ? classes.selectedItem
            : classes.nonselectedItem
        }
      >
        <Typography
          fontSize="0.82rem"
          fontWeight="400"
          color="Black"
          variant="h6"
          title={ele?.name}
        >
          {ele?.name?.length > 24 ? `${ele?.name.slice(0, 24)}...` : ele?.name}
        </Typography>

        {isMoveTopicTriggered && selectedChangeTopic?.id === ele?.id && (
          <Box position={"absolute"} top={-2} right={"31px"}>
            <Button
              onClick={handleSave}
              sx={{
                zIndex: "11",
                padding: "2.3px",
                fontSize: fontSizeSchemes.font14,
                fontWeight: 400,
                minWidth: "3rem",
                border: "1px solid grey",
                color: "black",
                textTransform: "none",
                bgcolor: colorSchemes.white,
                "&:hover": {
                  border: "1px solid grey",
                  bgcolor: colorSchemes.white,
                },
              }}
              variant="outlined"
            >
              Save
            </Button>
          </Box>
        )}

        {i !== 0 &&
          isTopicEditActive &&
          !isMoveTopicTriggered &&
          !isChangeTopicOpen && (
            <Box position={"absolute"} top={-2} right={"0"}>
              <Button
                onClick={(e) => {
                  e.stopPropagation();
                  handleEditTopicOpen(ele);
                }}
                size="small"
                variant="contained"
                sx={{
                  padding: "8px",
                  border: `0.5px solid ${colorSchemes.black}`,
                  backgroundColor: `${colorSchemes.white}`,
                  width: "1.87rem",
                  height: "1.87rem",
                  minWidth: "unset",
                  minHeight: "unset",
                  borderRadius: "0.15rem",
                  boxShadow: "none",
                  "&:hover": {
                    backgroundColor: `${colorSchemes.white}`,
                    boxShadow: "none",
                  },
                }}
              >
                <EditPencil color={"#000000"} />
              </Button>
            </Box>
          )}

        <Box position={"absolute"} top={-2} right={"0"}>
          {(isMoveTopicTriggered || isChangeTopicOpen) && (
            <FormControlLabel
              sx={{
                mr: 0,
                m: 0,
                padding: 0,
                "& .MuiFormControlLabel-label": {
                  display: "none",
                },
              }}
              control={
                <Box onClick={() => handleChangeMoveTopic(ele)}>
                  {isChangeTopicOpen ? (
                    selectedTopicToSaveMsg?.id === ele?.id ? (
                      <img
                        style={classes.checkBoxStyle}
                        src={SelectCheckBox}
                        alt="select"
                      />
                    ) : (
                      <img
                        style={classes.checkBoxStyle}
                        src={UnSelectCheckBox}
                        alt="select"
                      />
                    )
                  ) : selectedChangeTopic?.id === ele?.id ? (
                    <img
                      style={classes.checkBoxStyle}
                      src={SelectCheckBox}
                      alt="select"
                    />
                  ) : (
                    <img
                      style={classes.checkBoxStyle}
                      src={UnSelectCheckBox}
                      alt="select"
                    />
                  )}
                </Box>
              }
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};

const Topics = ({
  setisTopicOpen,
  handleSelectedTopic,
  isMoveTopicTriggered,
  setMoveTopicTriggered,
  moveTopicMsgId,
  setMoveTopicMsgId,
}) => {
  const [isAddTopicOpen, setIsAddTopicOpen] = useState(false);
  const [isEditTopicOpen, setIsEditTopicOpen] = useState(false);
  const [topicName, setTopicName] = useState("");
  const [searchToipcQuery, setSearchToipcQuery] = useState("");
  const [topicDetail, setTopicDetail] = useState({});
  const [selectedChangeTopic, setSelectedChangeTopic] = useState(null);
  const [isDeleteLoading, setDeleteLoading] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [activeId, setActiveId] = useState(null);
  const [isTopicEditActive, setIsTopicEditActive] = useState(false);

  const dispatch = useDispatch();
  const userData = useSelector((state) => state?.profile?.profileData);
  const selectedGroup = useSelector(
    (state) => state?.appStateData?.selectedGroupData
  );
  const selectedTopic = useSelector(
    (state) => state?.appStateData?.selectedTopicData
  );
  const selectedTopicToSaveMsg = useSelector(
    (state) => state?.appStateData?.selectedTopicToSaveMsg
  );
  const groupTopicData = useSelector((state) => state?.topic?.groupTopicData);
  const isChangeTopicOpen = useSelector(
    (state) => state?.appStateData?.isChangeTopicOpen
  );

  const filteredTopicData = groupTopicData?.data?.length
    ? groupTopicData.data
        .filter((item) =>
          item?.name?.toLowerCase().includes(searchToipcQuery.toLowerCase())
        )
        .sort((a, b) => a.order - b.order)
    : [];

  const handleInputChange = (e) => {
    setTopicName(e.target.value);
  };

  const handleAddTopic = () => {
    const formData = {
      group_id: selectedGroup?.id,
      name: topicName,
      description: "",
      subscriber_id: userData?.data?.activeSubscriber?.id,
    };
    if (topicName) {
      setLoading(true);
      dispatch(createTopic(formData)).then((res) => {
        // eslint-disable-next-line eqeqeq
        setLoading(false);
        setIsAddTopicOpen(false);
      });
    }
  };

  const handleEditTopicOpen = (data) => {
    setTopicDetail(data);
    setIsEditTopicOpen(true);
  };
  const handleEditTopicInputChange = (e) => {
    setTopicDetail({ ...topicDetail, name: e.target.value });
  };
  const handleEditTopic = () => {
    if (topicDetail) {
      setLoading(true);
      const newTopicData = { name: topicDetail?.name };
      dispatch(updateTopic(newTopicData, topicDetail?.id)).then((res) => {
        if (res?.status) {
          dispatch(getAlltopic({ group_id: selectedGroup?.id }));
        }
        setLoading(false);
        setIsEditTopicOpen(false);
      });
    }
  };

  const handleChangeMoveTopic = (topicData) => {
    if (isChangeTopicOpen) {
      dispatch(handleAppSelectedTopicToSaveMsg(topicData));
      dispatch(handleChangeTopicOpen(false));
    } else {
      setSelectedChangeTopic(topicData);
    }
  };

  const handleSave = () => {
    if (selectedChangeTopic) {
      dispatch(
        handleMoveChatToAnotherTopic(
          moveTopicMsgId?.pnId,
          moveTopicMsgId?.timetoken,
          selectedChangeTopic?.id
        )
      ).then((res) => {
        setMoveTopicMsgId(null);
        setMoveTopicTriggered(false);
      });
    }
    //setMoveTopicTriggered(false)
  };

  const handleAlternateBtnClick = async () => {
    setDeleteLoading(true);
    const response = await dispatch(
      handleDeleteGroupTopic(topicDetail?.id)).then((res) => {
      setDeleteLoading(false);
      if (res?.data?.status) {
       deleteTopicData(topicDetail?.id);
        setIsEditTopicOpen(false);
        dispatch(showToastMsg(res?.data?.message));
      } else {
        dispatch(showToastMsg(res?.data?.message || "Something went wrong !"));
      }
    });

    if (response?.data?.status) {
      setIsEditTopicOpen(false);
      dispatch(getAlltopic({ group_id: selectedGroup?.id }));
    }
  };

  const handleClickAllMessages = () => {
    dispatch(handleAppSelectedTopic(null));
    dispatch(handleFetchMessages(selectedGroup?.pnId, null));
  };

  // Drag and Drop sensors
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 0,
      },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  // Drag and Drop handlers
  const handleDragEnd = (event) => {
    const { active, over } = event;

    setActiveId(null);
    document.body.style.overflow = "auto";

    if (!over || active.id === over.id) return;

    const oldIndex = filteredTopicData.findIndex(
      (item) => item.id === active.id
    );

    const newIndex = filteredTopicData.findIndex(
      (item) => item.id === over.id
    );

    if (oldIndex === -1 || newIndex === -1) return;

    const reorderedTopicList = arrayMove(filteredTopicData, oldIndex, newIndex).map((item, order) => ({...item, order}));
    dispatch({type: GET_TOPIC_DONE,payload: reorderedTopicList});
    const reorderedPayload = reorderedTopicList.map((item, order) => ({id: item.id, order}));
    
    dispatch(handleReOrderToipc({order:reorderedPayload},selectedGroup?.id)).then((res)=>{
      if(!res?.data?.status){
      dispatch({type: GET_TOPIC_DONE,payload: filteredTopicData});
      dispatch(showToastMsg(res?.data?.message||res?.message));
      }
    });
  };

  return (
    <React.Fragment>
      <Stack sx={{ paddingLeft: "0", bgcolor: "#F9F8F8" }}>
        <StyledTopicsHeader sx={{ bgcolor: "#F9F8F8" }}>
          <Box display="flex" alignItems="center" gap={"0.5rem"}>
            <Typography sx={classes.iconDiv}>
              <CloseIcon
                sx={classes.iconn}
                onClick={() => {
                  setisTopicOpen(false);
                  setMoveTopicMsgId(null);
                  setMoveTopicTriggered(false);
                  dispatch(handleChangeTopicOpen(false));
                }}
              />
            </Typography>
            <Box>
              <Typography sx={classes.headingText} variant="h6">
                Topics
              </Typography>
            </Box>
          </Box>
          <Box display="flex" alignItems="center" gap={"0.3rem"}>
            <Button
              onClick={() => setIsTopicEditActive(!isTopicEditActive)}
              size="small"
              variant="contained"
              sx={{
                padding: "8px",
                border: `0.5px solid ${colorSchemes.black}`,
                backgroundColor: isTopicEditActive
                  ? `${colorSchemes.chipIconBlueColor}`
                  : `${colorSchemes.white}`,
                width: "1.87rem",
                height: "1.87rem",
                minWidth: "unset",
                minHeight: "unset",
                borderRadius: "0.15rem",
                boxShadow: "none",
                "&:hover": {
                  backgroundColor: isTopicEditActive
                    ? `${colorSchemes.chipIconBlueColor}`
                    : `${colorSchemes.white}`,
                  boxShadow: "none",
                },
              }}
            >
              <EditPencil color={isTopicEditActive ? "#FFFF" : "#000000"} />
            </Button>
            <StyledSidebarTopicButton
              onClick={() => setIsAddTopicOpen(true)}
              sx={{ display: "flex", alignItems: "center", gap: "4px" }}
              size="small"
            >
              <img src={addBlackIcom} alt="group" />
              Topic
            </StyledSidebarTopicButton>
          </Box>
        </StyledTopicsHeader>
        <StyledTopicSideBarInfoBox sx={{ bgcolor: "#F9F8F8" }}>
          <Box
            display="flex"
            justifyContent={"space-between"}
            alignItems="center"
          >
            <Box width={"100%"}>
              <SearchBox>
                <CustomInput
                  onChange={(e) => setSearchToipcQuery(e.target.value)}
                  placeholder="Search Topic"
                />
                <ChatSearchButton size="small" variant="contained">
                  <SmallIcon src={searchIcon} />
                </ChatSearchButton>
              </SearchBox>
            </Box>
            <Box>
              {isAddTopicOpen && (
                <>
                  {" "}
                  <InputDialogComponent
                    title="Add Topic"
                    open={isAddTopicOpen}
                    handleClose={() => setIsAddTopicOpen(false)}
                    onChange={handleInputChange}
                    btnLabel="Save"
                    isType="add"
                    inputLable="Topic Name"
                    onClick={handleAddTopic}
                    isLoading={isLoading}
                  />
                </>
              )}
            </Box>
          </Box>

          <Box
            height={"calc(100vh - 15.2rem)"}
            overflow="scroll"
            sx={{
              scrollbarWidth: "none",
              "&::-webkit-scrollbar": {
                width: "0px",
              },
              "&::-webkit-scrollbar-track": {
                background: "transparent",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "transparent",
              },
              "@media (max-width: 1194px)": {
                height: "calc(100vh - 18rem)",
              },
            }}
          >
            {isEditTopicOpen && (
              <>
                {" "}
                <InputDialogComponent
                  title="Edit/Delete Topic"
                  open={isEditTopicOpen}
                  handleClose={() => setIsEditTopicOpen(false)}
                  onChange={handleEditTopicInputChange}
                  btnLabel="Save"
                  isType="edit"
                  alternateBtnLabel="Delete"
                  value={topicDetail?.name}
                  inputLable="Topic Name"
                  onClick={handleEditTopic}
                  handleAlternateBtnClick={handleAlternateBtnClick}
                  isDeleteLoading={isDeleteLoading}
                  isLoading={isLoading}
                />
              </>
            )}

            {isChangeTopicOpen && (
              <Box
                display="flex"
                alignItems="center"
                gap={"0.6rem"}
                mt={"0.4rem"}
                bgcolor={"#183243"}
              >
                <Typography sx={classes.iconDivRed}>
                  <CloseIcon
                    sx={classes.iconnWhite}
                    onClick={() => dispatch(handleChangeTopicOpen(false))}
                  />
                </Typography>
                <Box>
                  <Typography color={"#fff"} fontSize={"0.84rem"}>
                    Change Topic
                  </Typography>
                </Box>
              </Box>
            )}
            {/* {!isMoveTopicTriggered && !isChangeTopicOpen && (
              <Box
                display="flex"
                alignItems="center"
                mt={"0.5rem"}
                gap={"0.3rem"}
                width={"100%"}
                // key={ele?.id + "topicdata" + i}
              >
                <Box
                  position={"relative"}
                  width={"100%"}
                  padding={"0.2rem 0.5rem"}
                  backgroundColor="#F3F3F3"
                  borderRadius="0.1rem"
                  onClick={() =>
                    !isMoveTopicTriggered && handleClickAllMessages()
                  }
                  sx={
                    // eslint-disable-next-line eqeqeq
                    selectedTopic?.id == null &&
                    !isMoveTopicTriggered &&
                    !isChangeTopicOpen
                      ? classes.selectedItem
                      : classes.nonselectedItem
                  }
                >
                  <Typography
                    fontSize="0.84rem"
                    fontWeight={600}
                    color="Black"
                    variant="h6"
                    // title={ele?.name}
                  >
                    All Messages
                  </Typography>
                </Box>
              </Box>
            )} */}
            <Box
              position={"relative"}
              width={"100%"}
              padding={"0.2rem 0.5rem"}
              borderRadius="0.1rem"
              title={"View Topic wise Chats"}
            >
              <Typography mt={"0.5rem"} fontSize={"0.84rem"} fontWeight={600}>
                View Topic wise Chats
              </Typography>
            </Box>
            <DndContext
              sensors={sensors}
              collisionDetection={closestCenter}
              onDragEnd={handleDragEnd}
              onDragStart={(event) => {
                setActiveId(event.active.id);
                // Prevent scrolling during drag
                document.body.style.overflow = "hidden";
              }}
              onDragCancel={() => {
                setActiveId(null);
                // Restore scrolling after drag
                document.body.style.overflow = "auto";
              }}
            >
              <SortableContext
                items={filteredTopicData?.map((item, i) => item?.id )}
                strategy={verticalListSortingStrategy}
              >
                {filteredTopicData?.map((ele, i) => {
                  return (
                    <SortableItem
                      ele={ele}
                      i={i}
                      isMoveTopicTriggered={isMoveTopicTriggered}
                      selectedTopic={selectedTopic}
                      isChangeTopicOpen={isChangeTopicOpen}
                      isTopicEditActive={isTopicEditActive}
                      selectedChangeTopic={selectedChangeTopic}
                      selectedTopicToSaveMsg={selectedTopicToSaveMsg}
                      handleChangeMoveTopic={handleChangeMoveTopic}
                      handleSave={handleSave}
                      handleSelectedTopic={handleSelectedTopic}
                      handleEditTopicOpen={handleEditTopicOpen}
                    />
                  );
                })}
              </SortableContext>
              <DragOverlay>
                {activeId ? (
                  <div
                    style={{
                      background: "white",
                      border: "1px solid #ddd",
                      borderRadius: "4px",
                      padding: "8px 12px",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                      opacity: 0.9,
                      pointerEvents: "none",
                      userSelect: "none",
                      maxWidth: "100%",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      cursor: "grab",
                    }}
                  >
                    {filteredTopicData.find((item, index) => item?.id === activeId)?.name || "Dragging..."}
                  </div>
                ) : null}
              </DragOverlay>
            </DndContext>
          </Box>
          {isMoveTopicTriggered && !isChangeTopicOpen && (
            <Box
              mt={"3rem"}
              textAlign={"center"}
              sx={{
                "@media (max-width: 1194px)": {
                  mt: "0rem",
                },
              }}
            >
              <Button
                onClick={() => setMoveTopicTriggered(false)}
                size="small"
                sx={{
                  backgroundColor: colorSchemes.transparent,
                  color: colorSchemes.black,
                  border: `1px solid ${colorSchemes.crossIconBorder}`,
                  padding: "0.4em 1.5em",
                  borderRadius: "0.15rem",
                  textTransform: "none",
                  ":hover": {
                    backgroundColor: colorSchemes.transparent,
                    color: colorSchemes.black,
                    border: `1px solid ${colorSchemes.crossIconBorder}`,
                  },
                }}
              >
                Close
              </Button>
            </Box>
          )}
        </StyledTopicSideBarInfoBox>
      </Stack>
    </React.Fragment>
  );
};

export default Topics;
